export const ListQueryKey = 'loveSpreads';
export const DetailQueryKey = 'loveSpread';

export const Urls = {
  selectUrl: '/loveSpread/list',
  updateUrl: '/loveSpread/update',
  deleteUrl: '/loveSpread/delete',
  createUrl: '/loveSpread/create',
  detailUrl: '/loveSpread/detail',
};
